var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('div',{staticClass:"mdui-row"},_vm._l((_vm.article),function(i){return _c('div',{key:i.id},[_c('WaterfallItem',{attrs:{"title":i.title,"time":i.time,"detail":i.detail,"link":i.link}})],1)}))]):_c('div',{staticClass:"mdui-spinner mdui-center mdui-valign mdui-m-t-4"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dda6ff6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaterFall.vue
// module id = null
// module chunks = 